import classNames from "classnames"
import { Button } from "primereact/button"

export const confirmFooter = (props) => {
  //console.log(props)
  return (
    <div className="flex justify-end w-full mt-3 gap-3">
      <div className="min-w-16" >
        <Button
          pt={{
            root: props.rejectClassName === 'p-confirm-dialog-reject p-button-text' ?
              classNames('bg-red-50 text-red-500',
                'outline-red-500 outline-2 outline ',
                'rounded-md w-full py-3 ',
                'hover:bg-red-200',
                'transition duration-300'
              ) :
              props.rejectClassName,
            }}
          label={props.rejectLabel}
          icon={props.rejectIcon}
          onClick={() => { props.reject() }}
        />
      </div>
      <div className="min-w-16" >
        <Button
          pt={{
            root: props.acceptClassName ===  "p-confirm-dialog-accept" ?
              classNames('bg-pague_verde text-white',
                'outline-green-700 outline-2 outline ',
                'rounded-md w-full py-3 ',
                'dark:text-black hover:bg-pague_verde_claro',
                'transition duration-300'
              ) :
              props.acceptClassName,
          }}
          label={props.acceptLabel}
          icon={props.acceptIcon}
          onClick={() => { props.accept() }}
        />
      </div>
    </div>
  )
}